//Archivo dedicado al menu de todos los imports de Firma Electrónica

//Imports relacionados de Firma Electrónica
//-----------Principal-----------
import Plantilla from '@/components/FirmaElectronica/Comun/Plantilla.vue';

//-----------Firmar documentos-----------
import FirmarDocumentos from '@/components/FirmaElectronica/FirmarDocumentos/FirmarDocumentos.vue';

//-----------Firmar documentos-----------
import CFirmaMultiple from '@/components/FirmaElectronica/FirmaMultiple/CFirmaMultiple.vue';

//Se crea la lista de paths
const firmaelectronica = [
  { name: 'FirmaElectronica', path: '/FirmaElectronica/', component: Plantilla, meta: { tituloDeLaPagina: "Firma Electrónica", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 10 }, children: [
    { name: 'FirmarDocumentos', path: 'FirmarDocumentos', component: FirmarDocumentos,  meta: { tituloDeLaPagina: "Firma Electrónica", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 10, EsRequeridoValidacionDeInstitucion: true } },
    { 
      name: 'FirmaElectronicaMultiple', 
      path: '/FirmaElectronicaMultiple', 
      component: CFirmaMultiple, 
      meta: { 
        tituloDeLaPagina: "Firma multiple de documentos", 
        RequiereAutenticacion: true, 
        ValidaSesion: true, 
        ObtenDatos: true, 
        ObtenPermisosDelSistema: true, 
        SistemaQueSeIngreso: 10
      } 
    }
  ] }
];

//Se regresa la lista de paths
export default firmaelectronica;



// WEBPACK FOOTER //
// ./src/router/FirmaElectronica.js